import * as Types from 'src/actions/payment/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Payment from 'src/entities/Payment';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetPaymentAttempt extends Action {
  type: Types.GET_PAYMENT_ATTEMPT;
}

export interface GetPaymentSuccess extends Action {
  type: Types.GET_PAYMENT_SUCCESS;
  payload: Payment;
}

export interface GetPaymentFailure extends Action {
  type: Types.GET_PAYMENT_FAILURE;
}

export type GetPaymentAction = GetPaymentAttempt |
  GetPaymentSuccess |
  GetPaymentFailure;

export interface GetPaymentThunk
  extends ThunkAction<Promise<GetPaymentAction>, RootState, string> {
}

export const getPaymentAttempt: ActionCreator<GetPaymentAttempt> = () => (
  {
    type: Types.GET_PAYMENT_ATTEMPT
  }
);

export const getPaymentSuccess: ActionCreator<GetPaymentSuccess> = (
  payment: Payment
) => ({
  type: Types.GET_PAYMENT_SUCCESS,
  payload: payment
});

export const getPaymentFailure: ActionCreator<GetPaymentFailure> = () => ({
  type: Types.GET_PAYMENT_FAILURE
});

export const getPayment: ActionCreator<GetPaymentThunk> = (
  investmentId: number,
): GetPaymentThunk => {
  return (dispatch: Dispatch<RootState>): Promise<GetPaymentAction> => {
    dispatch(getPaymentAttempt());

    return ApiClient.payment.index({ investmentId: investmentId })
      .then((response: AxiosResponse<{ investmentPayment: Payment }>): GetPaymentSuccess => {
        const payment: Payment = new Payment(response.data.investmentPayment);
        return dispatch(getPaymentSuccess(payment));
      }).catch((e: { response: { data: { error: {} } } }): GetPaymentFailure => {
        const errors = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

        return dispatch(getPaymentFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/payment/get/GetPayment.actions.tsx